<template>
	<div class="menu-footer" :class="{heatmapOpacity: menusStore.heatMap}">
		<div class="footer-buttons">
			<a v-if="showBookingButton" :href="bookingLink" class="booking-button">
				<span>{{ bookingButtonText }}</span>
				<span class="booking-icon" v-html="getIcon(bookingButtonIcon)"></span>
			</a>
			<LanguageSelector class="language-sel" :class="{marginBottom: menusStore.socials.length === 0}" />
			<ConsumerLogin v-if="!isKioskApp" />
		</div>
		<div class="socials-container" v-if="menusStore.socials.length > 0 && !isKioskApp">
			<div class="social-container" v-for="social in menusStore.socials">
				<a :href="social.link" target="_blank" v-html="getIcon(social.type)"></a>
			</div>
		</div>
		<div class="line" v-if="!isKioskApp"></div>
		<div class="logo-container" v-if="!isKioskApp">
			<a :href="URL_HTML" target="_blank"><img src="https://img.qromo.io/img/logo.png" alt="Qromo Logo"></a>
		</div>
		<div class="cookie-container">
			<a href="/cookies/" :target="isKioskApp ? null : '_blank'">{{ getString('cookie_policy') }}</a>
		</div>
		<div class="cookie-container">
			<a :href="linkPrivacy" :target="isKioskApp ? null : '_blank'">{{ getString('privacy_policy') }}</a>
		</div>
		<div class="cookie-container" v-if="menusStore.business.options.custom_terms">
			<a :href="menusStore.business.options.custom_terms" :target="isKioskApp ? null : '_blank'">{{ getString('terms_conditions') }}</a>
		</div>
	</div>
</template>

<script>
import LanguageSelector from "@/new-menu/components/modals/LanguageSelector.vue";
import ConsumerLogin from "@/new-menu/components/ConsumerLogin.vue";
import {useLanguageStore, useSvgStore} from "@/shared/stores";
import {useMenusStore} from "@/new-menu/stores";
import {isKioskApp} from "@/shared/helpers/webapp";

export default {
	setup() {
		let menusStore = useMenusStore();
		let svgStore = useSvgStore();
		return {getString: useLanguageStore().getString, getIcon: svgStore.get, menusStore}
	},
	name: "MenuFooter",
	components: {LanguageSelector, ConsumerLogin},
	data() {
		return {
			cookieLink: "/cookies/",
			URL_HTML: URL_HTML,
		}
	},
	computed: {
		isKioskApp() {
			return isKioskApp();
		},
		linkPrivacy() {
			return this.menusStore.business.options.custom_privacy ? this.menusStore.business.options.custom_privacy : "/privacy/";
		},
		bookingLink() {
			return window.location.pathname.includes('/book') ? '/' : '/book';
		},
		bookingButtonText() {
			return window.location.pathname.includes('/book') ? this.getString('menu') : this.getString('reservations');
		},
		bookingButtonIcon() {
			return window.location.pathname.includes('/book') ? 'iconMenu' : 'iconReservations';
		},
		showBookingButton() {
			return !this.isKioskApp && this.menusStore.business.options.menu_reservations_link && (window.location.pathname.includes('/book') || this.menusStore.hasExperiences);
		}
	}
}
</script>

<style scoped lang="scss">
.menu-footer {
	display: flex;
	flex-direction: column;

	.footer-buttons {
		display: flex;
		flex-direction: column;
		gap: 10px;
		padding: var(--padding-vertical) var(--padding-horizontal);

		.language-sel {
			margin: 0;
			padding: 0;

			&.marginBottom {
				margin-bottom: 0;
			}
		}

		.booking-button {
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 100%;
			height: 100%;
			padding: var(--padding-vertical) var(--padding-horizontal-s);
			cursor: pointer;
			background-color: var(--theme-bg2-color);
			border: 1px solid var(--business-color);
			border-radius: var(--rounded-corner);
			text-decoration: none;
			transition: opacity 0.2s ease-in-out;

			&:hover {
				opacity: 0.8;
			}

			span:first-child {
				font-family: var(--font-family);
				font-size: var(--font-size);
				line-height: var(--line-height);
				color: var(--theme-txt1-color);
			}

			.booking-icon {
				display: flex;
				align-items: center;
				justify-content: center;

				&:deep(svg) {
					width: 20px;
					height: 20px;

					.fill {
						fill: var(--business-color);
					}

					.stroke {
						stroke: var(--business-color);
					}
				}
			}

			&:after {
				display: none;
			}
		}
	}

	.socials-container {
		margin-bottom: var(--padding-vertical);
		display: flex;
		align-items: center;
		justify-content: center;
		gap: var(--padding-horizontal-s);

		.social-container {
			display: flex;
			align-items: center;
			justify-content: center;

			a {
				display: flex;
				padding: 2px;

				&:deep(svg) {
					width: 25px;
					height: 25px;
					object-fit: contain;
					border-radius: var(--rounded-corner);

					.fill {
						fill: var(--business-color);
					}

					.stroke {
						stroke: var(--business-color);
					}
				}

				&:after {
					display: none;
				}
			}
		}
	}

	.line {
		width: calc(100% - (var(--padding-horizontal) * 2));
		height: 1px;
		background-color: var(--theme-bg2-color);
		margin: 0 var(--padding-horizontal) var(--padding-vertical);
	}

	.logo-container {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: var(--padding-vertical);

		img {
			width: 30px;
			height: 30px;
			object-fit: contain;
		}

	}

	.cookie-container {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: var(--padding-vertical);

	}

	a {
		font-family: var(--font-family);
		font-size: var(--font-size-s);
		line-height: var(--line-height-s);
		color: var(--theme-txt2-color);
		text-decoration: none;

		&:after {
			display: none;
		}
	}
}
</style>